import { env } from 'next-runtime-env';
import posthog from 'posthog-js';
import SuperTokens from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';
import ThirdPartyPasswordless from 'supertokens-auth-react/recipe/thirdpartypasswordless';

export const initAuth = async () => {
  SuperTokens.init({
    appInfo: {
      appName: 'Vee Vision',
      apiDomain: env('AUTHENTICATION_DOMAIN') || '',
      apiBasePath: env('AUTHENTICATION_API_BASE_PATH') || '',
      websiteDomain: env('WEBSITE') || '',
      websiteBasePath: '/login',
    },
    recipeList: [
      Session.init({
        onHandleEvent: async (context) => {
          if (context.action === 'ACCESS_TOKEN_PAYLOAD_UPDATED') {
            // TODO
          } else if (context.action === 'API_INVALID_CLAIM') {
            // TODO
            console.log(
              `UNAUTHORISED ${JSON.stringify(
                context.userContext
              )}, claimValidationErrors = ${JSON.stringify(context.claimValidationErrors)}`
            );
          } else if (context.action === 'UNAUTHORISED') {
            // TODO
            console.log(
              `UNAUTHORISED ${JSON.stringify(context.userContext)}, sessionExpiredOrRevoked = ${
                context.sessionExpiredOrRevoked
              }`
            );
          } else if (context.action === 'REFRESH_SESSION') {
            // TODO
          } else if (context.action === 'SESSION_CREATED') {
            // TODO
          } else if (context.action === 'SIGN_OUT') {
            window.location.href = '/';
          }
        },
      }),
      ThirdPartyPasswordless.init({
        override: {
          functions: (originalImplementation) => {
            return {
              ...originalImplementation,
              createPasswordlessCode: async function (input) {
                try {
                  return await originalImplementation.createPasswordlessCode(
                    input
                  );
                } catch (error: any) {
                  //Handle not authorized to login to a tenant, clean the search params and tenant local store
                  // if (error.status === 403) {
                  //   logErrorToSentry(new Error('Forbidden login to a specific tenant'));
                  //   const urlWithoutQueryParams = window.location.pathname + window.location.hash;
                  //   window.history.pushState({}, document.title, urlWithoutQueryParams);
                  //   localStorage.removeItem('tenantId');
                  //   return {
                  //     fetchResponse: new Response(),
                  //     reason: 'You are not allowed to login',
                  //     status: 'SIGN_IN_UP_NOT_ALLOWED'
                  //   };
                  // }
                  // logErrorToSentry(error);
                  throw error;
                }
              },
            };
          },
        },
        signInUpFeature: {
          providers: [
            ThirdPartyPasswordless.Facebook.init(),
            ThirdPartyPasswordless.LinkedIn.init(),
          ],
        },
        contactMethod: 'EMAIL',
        onHandleEvent: async (context) => {
          if (context.action === 'SESSION_ALREADY_EXISTS') {
            // TODO:
          } else if (context.action === 'PASSWORDLESS_RESTART_FLOW') {
            // TODO:
          } else if (context.action === 'PASSWORDLESS_CODE_SENT') {
            // TODO:
          } else if (context.action === 'SUCCESS') {
            const user = context.user;
            let primaryEmail = '';
            for (const loginMethod of user.loginMethods) {
              if (
                loginMethod.recipeId === 'passwordless' ||
                loginMethod.recipeId === 'emailpassword'
              ) {
                primaryEmail = loginMethod.email || '';
                continue;
              }
            }
            posthog.identify(primaryEmail, {
              supertokensId: user.id,
              email: primaryEmail,
              emails: user.emails,
              loginMethods: user.loginMethods.map((method) => ({
                email: method.email,
                thirdParty: method.thirdParty,
                recipeId: method.recipeId,
              })),
            });
            // Extract the redirectToPath parameter from the URL
            const { search } = window.location;
            const urlParams = new URLSearchParams(search);

            const redirectToPath = urlParams.get('redirectToPath');

            // If redirectToPath is present, redirect to that path. Otherwise, you can redirect to a default path or handle accordingly.
            if (redirectToPath) {
              window.location.assign(decodeURIComponent(redirectToPath));
            }
            if (context.isNewRecipeUser) {
              // TODO: Sign up
            } else {
              // TODO: Sign in
            }
          }
        },
      }),
    ],
  });
};
